import CryptoJS from 'crypto-js';


// 判断当前设备
const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

const isIOS = () => {
  return /iPhone|iPad|iPod|iOS/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};


// 上报
const { reportH5SlsMsg } = window["metric-utils"];
const reportData = (event_name) => {
  reportH5SlsMsg("WH-H2407123-global", event_name, "");
}

// OSS图片地址
const OSS_IMAGE_URL = "https://lilithimage.oss-cn-shanghai.aliyuncs.com/wbpages/afk/activity/afk_header/image"


// app登录态打通解密
const ParseCrypto = (encrypt) => {
  // 解密密钥
  const aesKey = '36e49bb590d15856713b5d2f910f4ae3';
  const decrypt = CryptoJS.AES.decrypt(encrypt, CryptoJS.enc.Utf8.parse(aesKey), {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(CryptoJS.enc.Utf8);
  return decrypt;
}
// 解密后得到参数
const ParseString = (queryString) => {
  const params = new URLSearchParams(queryString);
  const result = {};
  for (const [key, value] of params.entries()) {
    result[key] = value;
  }
  return result;
}



export default {
  isMobile,
  reportData,
  isIOS,
  OSS_IMAGE_URL,
  ParseCrypto,
  ParseString
}